var _path, _path2, _path3, _path4, _circle, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWeightLossChart = function SvgWeightLossChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 170,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M297 160C163.658 160 118.299 35.73 3.017 35.003A1.01 1.01 0 0 0 2 36v123a1 1 0 0 0 1 1h294Z",
    fill: "url(#weight_loss_chart_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 35c116.033 0 161.267 125 295 125",
    stroke: "#66BF3C",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 35c61.299 0 91.948 60 124.513 60 32.565 0 40.227-34.737 64.651-34.737S226.123 95 248.153 95c22.029 0 24.423-42.632 48.847-42.632",
    stroke: "#FF4082",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M17 170V28M150 170V28M283 170V28",
    stroke: "#222"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 283,
    cy: 160,
    r: 5,
    fill: "#222",
    stroke: "#FEFBF9",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 35,
    r: 5,
    fill: "#222",
    stroke: "#FEFBF9",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "weight_loss_chart_svg__a",
    x1: 149.5,
    y1: 35,
    x2: 149.5,
    y2: 160,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#66BF3C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66BF3C",
    stopOpacity: 0
  })))));
};
export default SvgWeightLossChart;